import axiosService from './axios-service';
import { FeatureName } from 'src/utils/enums';
export interface AdvancedFeatureStateDto {
    featureType: FeatureName;
    blocked: boolean;
    enabled: boolean;
}

class AdvancedFeaturesService {
    public updateAdvancedFeatures = async (customerId: number, sid: number, externalId: string, advancedFeatureStateDto: AdvancedFeatureStateDto): Promise<any> => {
        const res = await axiosService.put(`/api/firewall/customer/${customerId}/service/${sid}/advanced-feature-state-ex`, {
            externalId,
            advancedFeatureStateDto
        });

        return res?.data;
    };
}

const advancedFeaturesService = new AdvancedFeaturesService();
export default advancedFeaturesService;
